module.exports = __webpack_public_path__ + "static/media/finish_image.73459120.png";